/* eslint-disable no-param-reassign */
/* disabling no-param-reassign based on RTK and immer best practices. */
import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
    appetizePreferences: {},
};

export const loginParamsSlice = createSlice({
    name: 'loginParamsSlice',
    initialState,
    reducers: {
        getAppetizePreferenceAction: () => {},
        setAppetizePreferenceAction: (state, action) => {
            state.appetizePreferences = action.payload;
        },
    },
});

export const {
    getAppetizePreferenceAction,
    setAppetizePreferenceAction,
} = loginParamsSlice.actions;

export default loginParamsSlice.reducer;
